/**
 * Container: .equal-height
 * Items:     .equal-height__item
 */
export function initEqualHeights() {
	const run = () => {
		document.querySelectorAll(".equal-height").forEach((root) => {
			const items = [...root.querySelectorAll(".equal-height__item")];
			const rows = {};

			items.forEach((el) => {
				el.style.minHeight = "";
			});

			items.forEach((el) => {
				const top = Math.round(el.getBoundingClientRect().top);
				(rows[top] ||= []).push(el);
			});

			Object.values(rows).forEach((row) => {
				if (row.length < 2) return;
				const max = Math.max(...row.map((el) => el.offsetHeight));
				row.forEach((el) => (el.style.minHeight = `${max}px`));
			});
		});
	};

	run();
	window.addEventListener("resize", run, { passive: true });
}
